/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboxMessageCreate
 */
export interface InboxMessageCreate {
    /**
     * 
     * @type {string}
     * @memberof InboxMessageCreate
     */
    header: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageCreate
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageCreate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageCreate
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageCreate
     */
    language_code: string;
}

/**
 * Check if a given object implements the InboxMessageCreate interface.
 */
export function instanceOfInboxMessageCreate(value: object): value is InboxMessageCreate {
    if (!('header' in value) || value['header'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    return true;
}

export function InboxMessageCreateFromJSON(json: any): InboxMessageCreate {
    return InboxMessageCreateFromJSONTyped(json, false);
}

export function InboxMessageCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboxMessageCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'header': json['header'],
        'message': json['message'],
        'name': json['name'],
        'url': json['url'],
        'language_code': json['language_code'],
    };
}

export function InboxMessageCreateToJSON(json: any): InboxMessageCreate {
    return InboxMessageCreateToJSONTyped(json, false);
}

export function InboxMessageCreateToJSONTyped(value?: InboxMessageCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': value['header'],
        'message': value['message'],
        'name': value['name'],
        'url': value['url'],
        'language_code': value['language_code'],
    };
}

